import AttributePanel from './components/AttributePanel.vue'

export default AttributePanel



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/attributePanel/index.js